import type { SupportStatusCategory } from 'features/my-zone/support-requests/types';

export const supportStatusCategories: Record<SupportStatusCategory, string[]> = {
    completed: ['Solved', 'Closed'],
    inProgress: ['New', 'In Progress', 'Data Entry', 'On Hold', 'Reopen'],
    pending: ['Pending'],
};

export const supportLocationRequests = ['Location Review', 'New Location Requests'];

export const supportRequestsTypes = ['locationRequests', 'generalRequests'];

export const EMAIL_INPUT_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const US_ZIP_CODE_REGEX = /^\d{5}(-\d{4})?$/;

export const LAT_REGEX =
    /^(\+|-)?(?:90(?:(?:\.0{1,12})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,12})?))$/;

export const LONG_REGEX =
    /^(\+|-)?(?:180(?:(?:\.0{1,12})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,12})?))$/;

export const COORDINATES_ERROR_MESSAGES = {
    outsideUS: 'These coordinates are located outside the U.S.',
    lat: 'Invalid latitude',
    lng: 'Invalid longitude',
};
